import { render, staticRenderFns } from "./TabsHead.vue?vue&type=template&id=a35498a8&scoped=true"
import script from "./TabsHead.vue?vue&type=script&lang=js"
export * from "./TabsHead.vue?vue&type=script&lang=js"
import style0 from "./TabsHead.vue?vue&type=style&index=0&id=a35498a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35498a8",
  null
  
)

export default component.exports